import { useDispatch } from 'react-redux';
import { useMutation } from '@tanstack/react-query';

import { setAppLoader } from '@/redux/common/CommonActions';
import { NOTIFICATION_TYPES, showNotification } from '@/views/components/Modals/notification';

import { sendEmailCarrier } from '../data-provider/send-email-carrier';
import type { SendEmailCarrierData } from '../data-provider/send-email-carrier/api';

export interface UseSendEmailCarrierOptions {
  onSuccess?: (data: unknown) => void;
  onError?: (error: Error) => void;
}

export const useSendEmailCarrier = (options?: UseSendEmailCarrierOptions) => {
  const dispatch = useDispatch();

  return useMutation({
    mutationFn: (data: SendEmailCarrierData) => sendEmailCarrier(data),
    onError: (error: Error) => {
      dispatch(setAppLoader(false));
      showNotification({
        message: 'Failed to send claim email.',
        type: NOTIFICATION_TYPES.ERROR,
      });
      options?.onError?.(error);
    },
    onMutate: () => {
      dispatch(setAppLoader(true));
    },
    onSuccess: (data, variables) => {
      dispatch(setAppLoader(false));

      const toEmails = variables.toEmail?.split(',')?.join(', ') || '';
      showNotification({
        message: `A mail to ${toEmails} has been sent`,
        type: NOTIFICATION_TYPES.SUCCESS,
      });

      options?.onSuccess?.(data);
    },
  });
};
